var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: {
        visible: _vm.visible,
        "custom-class": "process-drawer",
        size: "480px",
        title: _vm.$t("fixDutyFine.processRecord"),
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c(
        "div",
        { staticClass: "drawer-content" },
        [
          _c(
            "el-card",
            { staticClass: "info-card", attrs: { shadow: "never" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("div", { staticClass: "label" }, [
                        _vm._v(_vm._s(_vm.$t("fixDutyFine.waybillNumber"))),
                      ]),
                      _c("div", { staticClass: "value text-green" }, [
                        _vm._v(_vm._s(_vm.rowData.waybillNumber)),
                      ]),
                    ]),
                    _c("div", { staticClass: "info-item mt-10" }, [
                      _c("div", { staticClass: "label" }, [
                        _vm._v(_vm._s(_vm.$t("fixDutyFine.region"))),
                      ]),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.rowData.regionName)),
                      ]),
                    ]),
                    _c("div", { staticClass: "info-item mt-10" }, [
                      _c("div", { staticClass: "label" }, [
                        _vm._v(_vm._s(_vm.$t("fixDutyFine.penaltyType"))),
                      ]),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.rowData.responsibilityTypeName)),
                      ]),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("div", { staticClass: "label" }, [
                        _vm._v(_vm._s(_vm.$t("base.billingMonth"))),
                      ]),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.rowData.reconciliationPeriod)),
                      ]),
                    ]),
                    _c("div", { staticClass: "info-item mt-10" }, [
                      _c("div", { staticClass: "label" }, [
                        _vm._v(_vm._s(_vm.$t("fixDutyFine.site"))),
                      ]),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.rowData.siteName)),
                      ]),
                    ]),
                    _c("div", { staticClass: "info-item mt-10" }, [
                      _c("div", { staticClass: "label" }, [
                        _vm._v(_vm._s(_vm.$t("fixDutyFine.currentStatus"))),
                      ]),
                      _c("div", { staticClass: "value text-green" }, [
                        _vm._v(_vm._s(_vm.rowData.statusName)),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "timeline-section" },
            _vm._l(_vm.rowData.operationLogs, function (log, index) {
              return _c("div", { key: index, staticClass: "timeline-node" }, [
                _c("div", { staticClass: "node-header" }, [
                  _c("span", { staticClass: "node-title" }, [
                    _vm._v(_vm._s(log.operationType)),
                  ]),
                  _c("span", { staticClass: "node-date" }, [
                    _vm._v(_vm._s(log.operationTime)),
                  ]),
                ]),
                _c("div", { staticClass: "node-body" }, [
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$t("fixDutyFine.operatorLabel")) +
                        _vm._s(log.operatorName)
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$t("fixDutyFine.operationResultLabel")) +
                        _vm._s(log.operationResult)
                    ),
                  ]),
                ]),
              ])
            }),
            0
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }